import React from 'react'
import styled from 'styled-components'

// 원본 업로드 사진의 Google Vision 웹 매칭 검사 신호 표시
const SceneWebMatchSignal = props => {
  const { scene: p, getDate } = props

  // 업로드 사진 자체가 없는 씬(예: 캐릭터 기반)은 표시하지 않음
  if (!p.imageUrl) return null

  const renderSignal = () => {
    if (!p.webCheckStatus || p.webCheckStatus === 'pending') {
      return <div className="sig">⏳ 웹 매칭 검사 중...</div>
    }
    if (p.webCheckStatus === 'failed') {
      return (
        <div className="sig">
          ⚪ 웹 매칭 검사 실패{p.googleErrorReason ? ` — ${p.googleErrorReason}` : ''}
        </div>
      )
    }
    if (p.googleMatchLevel === 'EXACT_MATCH') {
      return (
        <div className="sig risk">
          🔴 웹 매칭: 동일 이미지 {p.googleMatchCount || 0}건
        </div>
      )
    }
    if (p.googleMatchLevel === 'SIMILAR_MATCH') {
      return (
        <div className="sig">
          🟡 웹 매칭: 유사 이미지 {p.googleMatchCount || 0}건
        </div>
      )
    }
    return <div className="sig">🟢 웹 매칭: 없음</div>
  }

  return (
    <SignalBox>
      {renderSignal()}
      <div className="tooltip">
        <div>
          웹 매칭:{' '}
          {p.googleMatchLevel === 'EXACT_MATCH'
            ? `동일 ${p.googleMatchCount || 0}건`
            : p.googleMatchLevel === 'SIMILAR_MATCH'
            ? `유사 ${p.googleMatchCount || 0}건`
            : p.googleMatchLevel === 'NO_MATCH'
            ? '없음'
            : '-'}
        </div>
        {p.googleTopEntity && <div>연관 항목: {p.googleTopEntity}</div>}
        <div>검사 시각: {p.webCheckedAt ? getDate(p.webCheckedAt) : '-'}</div>
      </div>
    </SignalBox>
  )
}

export default SceneWebMatchSignal

const SignalBox = styled.div`
  position: relative;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #eee;
  display: flex;
  flex-direction: column;
  row-gap: 2px;
  font-size: 12px;
  color: #333;
  cursor: default;

  .sig {
    line-height: 1.4;
  }

  .sig.risk {
    font-weight: 700;
    color: #dc3545;
  }

  .tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 10;
    width: max-content;
    max-width: 240px;
    padding: 8px 10px;
    background-color: rgba(0, 0, 0, 0.88);
    color: #fff;
    font-size: 11px;
    line-height: 1.5;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: opacity 0.15s ease;
    pointer-events: none;
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`
